export const useNavigationStore = defineStore(
  "Navigation",
  () => {
    const locked = ref(false);
    const previousNonSettingsRoute = ref<string>("/");

    const toggleLocked = () => {
      locked.value = !locked.value;
    };

    const setPreviousRoute = (route: string) => {
      previousNonSettingsRoute.value = route;
    };

    return {
      locked,
      toggleLocked,
      previousNonSettingsRoute,
      setPreviousRoute,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  }
);
